import { api } from 'utility';
import { getCreditUrl, getCostumerWithdrawlUrl, getDeleteCostumerWithdrawlUrl } from 'URLs';
// Cards

export function getWithdrawRules(params) {
  return api.get(getCostumerWithdrawlUrl(), { params }).then((res) => res.data);
}

export function deleteWithdrawRule(id) {
  return api.delete(getDeleteCostumerWithdrawlUrl(id)).then((res) => res.data);
}

export function getCredit(params) {
  return api.get(getCreditUrl(), { params }).then((res) => res.data);
}

export default {
  getWithdrawRules,
  deleteWithdrawRule,
  getCredit,
};
